import DialogCloseButton from "./DialogCloseButton";
import DialogBody from "./DialogBody";
import DialogFooter from "./DialogFooter";
import DialogHeader from "./DialogHeader";
import DialogTitle from "./DialogTitle";

const DialogLayout = {
  DialogHeader,
  DialogTitle,
  DialogCloseButton,
  DialogBody,
  DialogFooter
};

export default DialogLayout;
